<div class="list-item" (click)="click.emit($event)"><ng-content></ng-content></div>